import React from "react";

const DottedLoading = ({ text }) => {
  return (
    <div className="text-center flex justify-center items-center gap-2">
      {text}
      {/* <span className="flex space-x-1">
        <span className="w-1.5 h-1.5 bg-current rounded-full animate-bounce [animation-delay:0s]"></span>
        <span className="w-1.5 h-1.5 bg-current rounded-full animate-bounce [animation-delay:0.15s]"></span>
        <span className="w-1.5 h-1.5 bg-current rounded-full animate-bounce [animation-delay:0.3s]"></span>
      </span> */}
      <div className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default DottedLoading;
